module.exports = __webpack_public_path__ + "img/event_thumbnail.29d0ba3d.jpg";